<template>
  <div class="container-fluid pt-5 mt-5">
    <div class="row">
      <div class="col-sm-4 mb-3">
        <UserNav />
      </div>
      <div class="col-sm-8">
        <div class="row">
          <div
            class="offset-md-1 col-xl-5 col-md-5 mb-4 hover_pointer"
            @click="show = true"
          >
            <div class="card border-left-success shadow h-100 py-2">
              <div class="card-body">
                <div class="row no-gutters align-items-center">
                  <div class="col mr-2">
                    <div
                      class="text-xs font-weight-bold text-success text-uppercase mb-1"
                    >
                      AamCart Balance
                    </div>
                    <div class="h5 mb-0 font-weight-bold text-gray-800">
                      {{ wallet.txnAamcartBalance }}
                    </div>
                  </div>
                  <div class="col-auto">
                    <i class="fa fa-money fa-2x text-success"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-5 col-md-5 mb-4">
            <div
              class="card border-left-warning shadow h-100 py-2 hover_pointer"
              @click="show = false"
            >
              <div class="card-body">
                <div class="row no-gutters align-items-center">
                  <div class="col mr-2">
                    <div
                      class="text-xs font-weight-bold text-warning text-uppercase mb-1"
                    >
                      Rewards Balance
                    </div>
                    <div class="h5 mb-0 font-weight-bold text-gray-800">
                      {{ wallet.txnRewardsBalance }}
                    </div>
                  </div>
                  <div class="col-auto">
                    <i class="fa fa-google-wallet fa-2x text-warning"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card shadow">
          <div class=" card-header py-3">
            <span style="font-size:20px">
              Wallet History
            </span>
            <span>
              <b-btn
                variant="primary"
                class="pull-right p-2"
                @click="addShowadd()"
              >
                Redeem Coupon
              </b-btn>
            </span>
          </div>
          <div v-show="show">
            <table class="table">
              <tbody>
                <div class="row p-3" v-if="aamcartHistory.length == 0">
                  <div class="col-sm-12 text-center">
                    Aamcart Wallet History Not Found
                  </div>
                </div>
                <tr v-for="(aamcart, index) in aamcartHistory" :key="index">
                  <td>
                    <div v-if="aamcart.debitCredit == true">
                      <i class="ml-3 fa fa-money fa-3x text-danger"></i>
                    </div>
                    <div v-if="aamcart.debitCredit == false">
                      <i class="ml-3 fa fa-money fa-3x text-success"></i>
                    </div>
                    <div class="ml-3 mt-3">
                      {{
                        new Date(aamcart.createdAt * 1000).toLocaleDateString(
                          "en-us",
                          {
                            month: "short",
                            day: "numeric",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit"
                          }
                        )
                      }}
                    </div>
                  </td>

                  <td>
                    <div style="font-size:1.2em; font-weight:bold; color:#000">
                      <span v-if="aamcart.txtType == 0">Order Placed</span>
                      <span v-if="aamcart.txtType == 1">Order Returned</span>
                      <span v-if="aamcart.txtType == 2">Coupon Redeemed</span>
                      <span v-if="aamcart.txtType == 3">Referral Reward</span>
                    </div>
                    <div>Ref Id :- {{ aamcart.refernceId }}</div>
                    <div>Txn Id : {{ aamcart.id }}</div>
                  </td>
                  <td>
                    <div
                      v-if="aamcart.debitCredit == true"
                      class="text-danger m-1"
                      style="font-size:1.5em; font-weight:bold"
                    >
                      {{ aamcart.txnAmt }}
                    </div>
                    <div v-if="aamcart.debitCredit == true" class="pt-3">
                      Debit
                    </div>
                    <div
                      v-if="aamcart.debitCredit == false"
                      class="text-success m-1"
                      style="font-size:1.5em;font-weight:bold"
                    >
                      {{ aamcart.txnAmt }}
                    </div>
                    <div v-if="aamcart.debitCredit == false" class="pt-3">
                      Credit
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-show="!show">
            <table class="table">
              <tbody>
                <div class="row p-3" v-if="rewardHistory.length == 0">
                  <div class="col-sm-12 text-center">
                    Rewards History Not Found
                  </div>
                </div>
                <tr v-for="(rewards, index) in rewardHistory" :key="index">
                  <td>
                    <div v-if="rewards.debitCredit == true">
                      <i class="ml-3 fa fa-google-wallet fa-3x text-danger"></i>
                    </div>
                    <div v-if="rewards.debitCredit == false">
                      <i
                        class="ml-3 fa fa-google-wallet fa-3x text-success"
                      ></i>
                    </div>
                    <div class="ml-3 mt-3">
                      {{
                        new Date(rewards.createdAt * 1000).toLocaleDateString(
                          "en-us",
                          {
                            month: "short",
                            day: "numeric",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit"
                          }
                        )
                      }}
                    </div>
                  </td>

                  <td>
                    <div style="font-size:1.2em; font-weight:bold; color:#000">
                      <span v-if="rewards.txtType == 0">Order Placed</span>
                      <span v-if="rewards.txtType == 1">Order Returned</span>
                      <span v-if="rewards.txtType == 2">Coupon Redeemed</span>
                      <span v-if="rewards.txtType == 3">Referral Reward</span>
                    </div>
                    <div>Ref Id :- {{ rewards.refernceId }}</div>
                    <div>Txn Id : {{ rewards.id }}</div>
                  </td>
                  <td>
                    <div
                      v-if="rewards.debitCredit == true"
                      class="text-danger m-1"
                      style="font-size:1.5em; font-weight:bold"
                    >
                      {{ rewards.txnAmt }}
                    </div>
                    <div v-if="rewards.debitCredit == true" class="pt-3">
                      Debit
                    </div>
                    <div
                      v-if="rewards.debitCredit == false"
                      class="text-success m-1"
                      style="font-size:1.5em;font-weight:bold"
                    >
                      {{ rewards.txnAmt }}
                    </div>
                    <div v-if="rewards.debitCredit == false" class="pt-3">
                      Credit
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <b-modal v-model="ShowModel" title="Apply Coupon" hide-footer>
        <div v-if="loading">
          <sweetalert-icon class="text-center" :icon="Loadingtype" />
          <h3 class="text-center">{{ loadingMsg }}</h3>
        </div>
        <b-form class="row" v-on:submit.prevent="AddCoupon" v-else>
          <div class="col-md-12">
            <b-form-group label="Coupon Code:">
              <b-form-input
                v-model="couponCode"
                type="text"
                class="form-control"
                required
                placeholder="Enter Coupon Code"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6 ">
            <button type="submit" class="btn btn-success form-control">
              Apply Coupon
            </button>
          </div>
        </b-form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { dbFs } from "@/modules/database";
import { mapGetters } from "vuex";
import UserNav from "@/components/UserNav.vue";

export default {
  data: () => {
    return {
      Loadingtype: "loading",
      loadingMsg: "",
      loading: false,
      show: false,
      couponCode: "",
      coupanId: "",
      wallet: {
        txnAamcartBalance: 0,
        txnRewardsBalance: 0
      },
      rewardHistory: [],
      aamcartHistory: [],
      couponData: [],
      uId: "Uutdn2SpCfMNqGXodTxnegWwTFf1",
      ShowModel: false
    };
  },
  components: {
    UserNav
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
  mounted() {
    this.setupFirebaseReading();
  },
  methods: {
    setupFirebaseReading: function() {
      this.loading = true;
      this.$bind("wallet", dbFs.collection("wallet").doc(this.user.uid))
        .then(() => {
          if (this.wallet.txnRewardsBalance == null) {
            let walletData = {
              txnRewardsBalance: 0
            };
            dbFs
              .collection("wallet")
              .doc(this.user.uid)
              .set(walletData, { merge: true });
          }
          if (this.wallet.txnAamcartBalance == null) {
            let walletData = {
              txnAamcartBalance: 0
            };
            dbFs
              .collection("wallet")
              .doc(this.user.uid)
              .set(walletData, { merge: true });
          }
          this.getHistory();
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getHistory() {
      this.$bind(
        "rewardHistory",
        dbFs
          .collection("wallet")
          .doc(this.user.uid)
          .collection("txnRewardsBalance")
          .where("txnStatus", "==", true)
      )
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.$bind(
            "aamcartHistory",
            dbFs
              .collection("wallet")
              .doc(this.user.uid)
              .collection("txnAamcartBalance")
              .where("txnStatus", "==", true)
              .catch(error => {
                console.log(error);
              })
          ).finally(() => {
            this.loading = false;
          });
        });
    },
    addShowadd() {
      this.ShowModel = !this.ShowModel;
    },
    AddCoupon() {
      this.loading = true;
      dbFs
        .collection("coupon")
        .where("code", "==", this.couponCode)
        .where("type", "==", 1)
        .get()
        .then(doc => {
          if (doc.empty) {
            this.loadingMsg = "Coupan Invalid";
            this.Loadingtype = "error";
          } else {
            doc.forEach(docs => {
              this.coupanId = docs.id;
              this.couponData = docs.data();
            });
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          if ((this.coupanId === "") | (this.coupanId === undefined)) {
            this.loadingMsg = "Coupan Invalid";
            this.Loadingtype = "error";
            setTimeout(() => {
              this.ShowModel = false;
              this.loading = false;
              this.Loadingtype = "loading";
              this.couponCode = "";
              this.coupanId = "";
            }, 3000);
          } else {
            dbFs
              .collection("wallet")
              .doc(this.user.uid)
              .collection("txnRewardsBalance")
              .where("refernceId", "==", this.coupanId)
              .get()
              .then(doc => {
                if (doc.empty == false) {
                  this.Loadingtype = "error";
                  this.loadingMsg = "Allredy Used";
                } else {
                  this.UpdateData();
                }
              })
              .finally(() => {
                setTimeout(() => {
                  this.show = false;
                  this.loading = false;
                  this.Loadingtype = "loading";
                  this.loadingMsg = "";
                  this.couponCode = "";
                  this.coupanId = "";
                  this.ShowModel = false;
                }, 3000);
              });
          }
        });
    },
    UpdateData() {
      let txnData = {
        refernceId: this.coupanId,
        txnAmt: this.couponData.value,
        txnStatus: true,
        pendingBalance: this.wallet.txnRewardsBalance,
        debitCredit: false,
        createdAt: Math.round(+new Date() / 1000),
        txtType: 2
      };
      let UpdateData = {
        txnRewardsBalance: this.wallet.txnRewardsBalance + this.couponData.value
      };
      dbFs
        .collection("wallet")
        .doc(this.user.uid)
        .collection("txnRewardsBalance")
        .add(txnData)
        .then(() => {
          dbFs
            .collection("wallet")
            .doc(this.user.uid)
            .set(UpdateData, { merge: true });
        })
        .finally(() => {
          this.Loadingtype = "success";
          this.loadingMsg = "Coupon Redeem Successful";
          setTimeout(() => {
            this.show = false;
            this.loading = false;
            this.couponData = [];
            this.coupanId = "";
            this.couponCode = "";
            this.ShowModel = false;
          }, 3000);
        });
    }
  }
};
</script>

<style>
.list-group-item.active {
  background-color: #51381b !important;
  border-color: #51381b;
}
.hover_pointer :hover {
  cursor: pointer;
}
</style>
